export default "__VITE_ASSET__DaUtAyrQ__"